import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/CardPage/CardPageComponent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
